import React, { useState, useEffect } from 'react';
import { collection, getDocs, deleteDoc, query } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { useAuth } from '../../context/AuthContext';

function DashboardHome() {
  const { user } = useAuth();
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalBlogs: 0,
    totalAutomations: 0,
    totalOrders: 0
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [users, blogs, automations] = await Promise.all([
          getDocs(collection(db, 'users')),
          getDocs(collection(db, 'blogs')),
          getDocs(collection(db, 'automations'))
        ]);

        setStats({
          totalUsers: users.size,
          totalBlogs: blogs.size,
          totalAutomations: automations.size,
          totalOrders: 0 // Sipariş sistemi eklenince güncellenecek
        });
      } catch (error) {
        console.error('İstatistik yükleme hatası:', error);
      }
    };

    fetchStats();
  }, []);

  const resetDatabase = async () => {
    if (!user || user.role !== 'admin') {
      alert('Bu işlemi sadece admin yapabilir! Editor veya diğer yetkili kullanıcılar bu işlemi yapamaz.');
      return;
    }

    // Ekstra güvenlik kontrolü
    const adminPassword = prompt('Güvenlik için admin şifrenizi girin:');
    if (!adminPassword) {
      return;
    }

    // Şifre kontrolü (burada basit bir kontrol yapıyoruz, gerçek uygulamada daha güvenli bir yöntem kullanılmalı)
    if (adminPassword !== 'admin123') {
      alert('Yanlış şifre! Bu işlem sadece admin tarafından yapılabilir.');
      return;
    }

    const isConfirmed = window.confirm(
      'DİKKAT: Veritabanını sıfırlamak üzeresiniz. Bu işlem geri alınamaz! Tüm veriler silinecektir. Devam etmek istediğinizden emin misiniz?'
    );

    if (!isConfirmed) return;

    const secondConfirm = window.confirm(
      'Son bir kez daha onaylayın: Tüm veriler kalıcı olarak silinecektir!'
    );

    if (!secondConfirm) return;

    try {
      // Silinecek koleksiyonlar
      const collections = ['questions', 'blogs', 'automations', 'answers'];

      for (const collectionName of collections) {
        const q = query(collection(db, collectionName));
        const querySnapshot = await getDocs(q);
        
        // Her bir koleksiyondaki dökümanları sil
        const deletePromises = querySnapshot.docs.map(doc => 
          deleteDoc(doc.ref)
        );
        
        await Promise.all(deletePromises);
      }

      alert('Veritabanı başarıyla sıfırlandı!');
    } catch (error) {
      console.error('Veritabanı sıfırlanırken hata:', error);
      alert('Veritabanı sıfırlanırken bir hata oluştu!');
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Hoş Geldiniz, {user?.name || 'Admin'}</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-semibold mb-2">Kullanıcılar</h2>
          <p className="text-3xl font-bold text-blue-600">{stats.totalUsers}</p>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-semibold mb-2">Blog Yazıları</h2>
          <p className="text-3xl font-bold text-green-600">{stats.totalBlogs}</p>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-semibold mb-2">Otomasyonlar</h2>
          <p className="text-3xl font-bold text-purple-600">{stats.totalAutomations}</p>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-semibold mb-2">Siparişler</h2>
          <p className="text-3xl font-bold text-orange-600">{stats.totalOrders}</p>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold mb-4">Sosyal Medya</h2>
        <div className="flex space-x-4">
          <a
            href="https://www.instagram.com/excelvbamakro/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-4 py-2 rounded hover:opacity-90"
          >
            Instagram
          </a>
          <a
            href="https://www.shopier.com/ShowProductNew/storefront.php?shop=excelvbamakro"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-blue-600 text-white px-4 py-2 rounded hover:opacity-90"
          >
            Shopier
          </a>
        </div>
      </div>

      {/* Sadece admin için veritabanı sıfırlama butonu göster */}
      {user?.role === 'admin' && (
        <div className="mt-8">
          <h2 className="text-xl font-semibold mb-4">Veritabanı Yönetimi</h2>
          <button
            onClick={resetDatabase}
            className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
          >
            Veritabanını Sıfırla
          </button>
          <p className="mt-2 text-sm text-gray-500">
            Bu işlem tüm verileri kalıcı olarak silecektir. Sadece admin tarafından kullanılabilir!
          </p>
        </div>
      )}
    </div>
  );
}

export default DashboardHome;